import React, { useState } from "react";
import { Tabs } from "antd";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const TypesDistributionChart = ({ infractionData=[], warningData=[] }) => {
  const [activeTab, setActiveTab] = useState("infractions");

  const getChartOptions = (data, title) => ({
    chart: {
      type: "pie",
    },
    title: {
      text: title,
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        name: activeTab === "infractions" ? "Infractions" : "Avertissements",
        data: data.map((item) => ({
          name: item.type,
          y: item.value,
        })),
      },
    ],
  });

  const items = [
    {
      key: "infractions",
      label: "Infractions",
      children: (
        <HighchartsReact
          highcharts={Highcharts}
          options={getChartOptions(
            infractionData,
            "Répartition des Types d'Infractions"
          )}
        />
      ),
    },
    {
      key: "warnings",
      label: "Avertissements",
      children: (
        <HighchartsReact
          highcharts={Highcharts}
          options={getChartOptions(
            warningData,
            "Répartition des Types d'Avertissements"
          )}
        />
      ),
    },
  ];

  return (
    <Tabs
      activeKey={activeTab}
      items={items}
      onChange={setActiveTab}
      className="w-full"
    />
  );
};

export default TypesDistributionChart;